module.exports = __webpack_public_path__ + "img/3-6.647290f5.png";